// extracted by mini-css-extract-plugin
export default {"day":"PayslipCard_day__gbH3i","cash":"PayslipCard_cash__gFeUN"};